import { CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const clearEligibleDelegateStructEmployeesAction = () => {
    return {
        type: CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES,
    };
};